// Libs
import React, { useState, useEffect } from 'react';
import { Collapse, Icon } from 'antd';
import { PaginationConfig } from 'antd/lib/pagination';
import { useSetRecoilState } from 'recoil';

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
  ICrfFechamentoResult,
  getAllCrfFechamento,
  getCrfFechamentoAtual,
  solicitarGeracaoDoRelatorioCrfFechamento,
} from '@app/api/crf/crffechamento';

import { getAllHistoricoExecucaoRotinaContaResultadoFechamentoMina } from '@app/api/parametro';

//Files
import { listHistoricoExecucaorotina } from '@app/state/atom';
import TableExecucaoRotina from '@app/views/Configuracao/TableExecucaoRotina';

//Utils
import { hasPermission } from '@app/helpers/permissions';
import { crfAtualizarRelatorioADistribuirRelatorio, crfSolicitacaoExecucaoRotinaRelatorioProjetoPacote } from '@app/api/crf/crfRoutines';


const { Panel } = Collapse;
const colums = () => {
  return [
    {
      title: 'N',
      dataIndex: 'index',
      with: '2%',
    },
    {
      title: 'Mês/Ano',
      dataIndex: 'mesAno',
      with: '68%',
      render: (text, record, index) => {
        return <> {record.mes + '/' + record.ano} </>;
      },
    },
    {
      title: 'Data execução',
      dataIndex: 'createdAtFormatado',
      with: '10%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      with: '10%',
    },
  ];
};

const CrfRotinaFechamento = () => {
  const [dataMesANo, setMesAno] = useState('');
  const [allFechamento, setAllFechamento] = useState<ICrfFechamentoResult[]>([]);
  const setHistoricosRotinas = useSetRecoilState(listHistoricoExecucaorotina);

  const getAll = async () => {
    const result = await getAllCrfFechamento();
    if (result && Array.isArray(result)) {
      setAllFechamento(result);
    }
  };


  useEffect(() => {
    getCrfFechamentoAtual().then(dataAtual => {
      if (dataAtual) {
        setMesAno(dataAtual);
      }
    });
    getAll();
  }, []);



  const hasSolicitarGeracaoDoRelatorioFechamento = () => {
    solicitarGeracaoDoRelatorioCrfFechamento();
  };

  const solicitarCriacaoProjetoPacote = () => {
    crfSolicitacaoExecucaoRotinaRelatorioProjetoPacote();
  }

  useEffect(() => {
    getHistoricoData();
  }, [])

  useEffect(() => {
    const intervalId = setInterval(() => {
      getHistoricoData();
    }, 60000)
    return () => clearInterval(intervalId);
  }, [useState]);

  const getHistoricoData = async () => {
    const result = await getAllHistoricoExecucaoRotinaContaResultadoFechamentoMina();
    if (result) {
      setHistoricosRotinas(result);
    } else {
      setHistoricosRotinas([]);
    }
  };

  return (
    <ui.SimpleView>
      <ui.GridView noform>


        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="1" header="SOLICITAR CRIAÇÃO DO FECHAMENTO" style={{ border: 0 }}>
            <ui.MasterDetailForm
              initialValues={dataMesANo}
              onSubmit={values => {
                hasSolicitarGeracaoDoRelatorioFechamento();
              }}>
              <ui.Widget
                actions={[
                  hasPermission(['SOLICITAR_CRIACAO_FECHAMENTO']) && (
                    <ui.FormSubmitButton type="primary">
                      <ui.FormatText id="ui.commons.save" uppercase />
                    </ui.FormSubmitButton>
                  ),
                ]}>
                <ui.FormInput label="Mes/Ano" name="mesAno" span={2} disabled={true} />
              </ui.Widget>
            </ui.MasterDetailForm>
          </Panel>
        </Collapse>

        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="2" header="RESUMO FECHAMENTO" style={{ border: 0 }}>
            <ui.Widget>
              <ui.Table
                columns={colums()}
                dataSource={allFechamento}
                pagination={
                  {
                    pageSize: 5,
                  } as PaginationConfig}
              />

            </ui.Widget>
          </Panel>
        </Collapse>

        <Collapse
          defaultActiveKey={['3']}
          bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="3" header="Relatório das rotinas do sistema" style={{ border: 0 }}>
            <ui.Widget actions={
              [
                <ui.Button
                  type="primary"
                  size={'small'}
                  icon="business-request_service"
                  onClick={() => {
                    solicitarCriacaoProjetoPacote()
                  }}
                >
                  Solicitar criação do relatório PROJETO PACOTE
                </ui.Button>,
                <ui.Button
                  type="primary"
                  size={'small'}
                  icon="business-request_service"
                  onClick={() => {
                    crfAtualizarRelatorioADistribuirRelatorio()
                  }}
                >
                  Atualizando Relatório Verificação de Erros
                </ui.Button>
              ]}>

              <TableExecucaoRotina />
            </ui.Widget>
          </Panel>
        </Collapse>

      </ui.GridView>
    </ui.SimpleView>
  );
};

export default CrfRotinaFechamento;
